import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActiveReactivateList from "./ActiveReactivateList";
import {
  getoffRoleEmployeesData,
  getDataForDropdown,
  citiesDropdownData,
  zonesDropdownData,
  departmentDropdownData,
  teamDropdownData,
  areasDropdownData,
  reportingManagerDropdownData,
  assignLocationsToUser,
  assignReporteeToUser
} from "services/redux/OffRoleEmployees/action";

const mapStateToProps = (state) => ({
  getEmployeesListing: state.offroleEmployeesReducer.getEmployeesListing,
  getDropdownDatas: state.offroleEmployeesReducer.getDropdownDatas,
  departmentDropwdownResponse: state.offroleEmployeesReducer.departmentDropwdownResponse,
  teamDropdownResponse: state.offroleEmployeesReducer.teamDropdownResponse,
  roleDropdownResponse: state.offroleEmployeesReducer.roleDropdownResponse,
  reportingManagerResponse: state.offroleEmployeesReducer.reportingManagerResponse,
  citiesDropdownResponse: state.offroleEmployeesReducer.citiesDropdownResponse,
  zonesDropdownResponse: state.offroleEmployeesReducer.zonesDropdownResponse,
  areasDropdownResponse: state.offroleEmployeesReducer.areasDropdownResponse
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getoffRoleEmployeesData,
      getDataForDropdown,
      citiesDropdownData,
      zonesDropdownData,
      departmentDropdownData,
      teamDropdownData,
      areasDropdownData,
      reportingManagerDropdownData,
      assignLocationsToUser,
      assignReporteeToUser
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActiveReactivateList);
